import React from 'react'
import {LoginMenu} from './loginmenu.react.js'
import {UserMenu} from './usermenu.react.js'


const inlineElem = {
  display: "inline"
};

const HeaderMenu = (props) => {
  if (!props.show_user) {
    return <LoginMenu />
  }
  else {
    return <UserMenu show_user={props.show_user}/>
  }
}

export default () => (
  <div>
  <div className='headline'>
    <h1 style={{margin:'0px'}}><a href='/'>一番見やすい池袋風俗情報サイト - 池袋紳士</a></h1>
    <p>各店舗の在籍嬢・出勤情報を独自に収集して見やすく表示。スマホも対応！</p>
  </div>
  <nav className="navbar navbar-default" role="navigation">
    <div className="container-fluid">
      <div className="navbar-header">
        <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1">
          <span className="sr-only">Toggle navigation</span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
        </button>
        <a className="navbar-brand" href="/">
          <img src="/static/images/magicians32.png" style={inlineElem} />
          池袋紳士
        </a>
      </div>
      <HeaderMenu show_user={window.show_user}/>
    </div>
  </nav>
  </div>
)



// WEBPACK FOOTER //
// ./components/header.react.js